const resetMeta = (meta: ComputedRef<FormMeta>) => {
  meta.value.dirty = false;

  Object.keys(meta.value.touched).forEach((key) => {
    meta.value.touched[key] = false;
  });
};

export { resetMeta };
